export default __webpack_public_path__ + "static/media/no-aprobada.ba8e33e0.svg";